import { combineReducers } from 'redux';

// import importProgress from './import-progress';
import user from './user';
import designs from './designs';
import ui from './ui';

// https://medium.com/@kylpo/redux-best-practices-eef55a20cc72


/* Store Tree:

	– user
		- status: false / "personal / developer / studio" // false ex: premiumUser
		-
	- designs
		- designsCount: int // 0 ex: designsCount
		- importedSets: [] or [ basic, premium, etc ] // ex: importedBasic, importedPremium
		- designLibrary: []/false // false ex: designLibrary
	- ui
		- currentPanel: false/id // false ex: currentPanel
		- messages: false/ [] // false ex: errorMessage
		- importProgress:
			- importing: true/false // false ex: importing
			- total: 0
			- imported: 0
*/

export default combineReducers( {
	// importProgress,
	user: user,
	designs: designs,
	ui: ui,
} )


// WEBPACK FOOTER //
// ./src/reducers/index.js